var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 31",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.549.927c.3-.921 1.603-.921 1.902 0l3.09 9.51a1 1 0 00.951.692h10c.97 0 1.372 1.24.588 1.809l-8.09 5.878a1 1 0 00-.363 1.118l3.09 9.51c.3.922-.755 1.688-1.539 1.118l-8.09-5.878a1 1 0 00-1.176 0l-8.09 5.878c-.784.57-1.838-.196-1.539-1.118l3.09-9.51a1 1 0 00-.363-1.118L.92 12.938c-.784-.57-.381-1.81.588-1.81h10a1 1 0 00.95-.69l3.09-9.511z"
  })));
};
export default SvgStar;